import './App.css';
import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from 'react';
import IntroAnimation from './components/introAnimation/IntroAnimation';
import MainLayout from './components/layouts/MainLayout';
import { Home } from './pages/home/Home';
// import Services from './pages/services/Services';
import Packages from './pages/packages/Packages';
import HousePlanning from './pages/services/HousePlanning';
import PlanApproval from './pages/services/PlanApproval';
import Construction from './pages/services/Construction';
import Interior from './pages/services/Interior';
import DesignPackage from './pages/packages/DesignPackage';
import ConstructionPackage from './pages/packages/ConstructionPackage';
// import Projects from './pages/projects/Projects';
// import ProjectDetails from './pages/projects/ProjectDetails';
// import AboutUs from './pages/about/AboutUs';
import Contact from './pages/contact/Contact';
import OpenWidget from './components/common/OpenWidget';
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  const [showIntro, setShowIntro] = useState(false);

  useEffect(() => {
    // Check if the intro has already played in this session
    const hasSeenIntro = sessionStorage.getItem('hasSeenIntro_v1');
    if (!hasSeenIntro) {
      setShowIntro(true);
    }
  }, []);

  const handleIntroComplete = () => {
    setShowIntro(false);
    sessionStorage.setItem('hasSeenIntro_v1', 'true');
  };

  return (
    <>
      {showIntro && <IntroAnimation onComplete={handleIntroComplete} />}
      <OpenWidget />
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/services/planning" element={<HousePlanning />} />
          <Route path="/services/approval" element={<PlanApproval />} />
          <Route path="/services/construction" element={<Construction />} />
          <Route path="/services/interior" element={<Interior />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/design" element={<DesignPackage />} />
          <Route path="/packages/construction" element={<ConstructionPackage />} />
          {/* <Route path="/projects" element={<Projects />} /> */}
          {/* <Route path="/projects/:id" element={<ProjectDetails />} /> */}
          {/* <Route path="/aboutUs" element={<AboutUs />} /> */}
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
